import { render } from "./FormFields.vue?vue&type=template&id=ed0458f2"
import script from "./FormFields.vue?vue&type=script&lang=js"
export * from "./FormFields.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__